import React from 'react';
import BundleItemTitles from '../Shared/BundleItemTitles';
import {ColumnHtml, ColumnTwoPartsHtml} from '../Shared/sharedHtmlComponents';
import {isMobile} from 'react-device-detect';
import CategoryName from '../Shared/CategoryName';
import ServiceBoxTiny from '../../../Shared/ServiceBox/ServiceBoxTiny/ServiceBoxTiny';
import {productsTypes} from '../productsAndServicesBlockSlice';
import {Button} from 'reactstrap';

const BundleItem = (props) => {
  const widthList = ['20', '25', '25'];

  return (
    <div className={`productAndServicesItemContainer ${props.type}`}>
      <CategoryName title={'חבילה משולבת'} imageName={`${isMobile ? 'bundle' : 'bundle-desc'}`} />
      {props.bundleItems?.map((bundleItem, index) => {
        let premiumCount, equipment;
        if (bundleItem.tvItem) {
          premiumCount = `${bundleItem.tvItem.premiumPackagesCount} חבילות`;
          equipment = bundleItem.tvItem.equipmentCount == 1 ? 'ממיר אחד' : `${bundleItem.tvItem.equipmentCount} ממרים`;
        }

        return (
          <div key={index}>
            {!isMobile ? (
              <div className='productAndServicesItemContainer_content_bundle_wrapper'>
                <BundleItemTitles
                  bundleName={bundleItem.packageName}
                  address={bundleItem.customerAddress}
                  bundleNameWidth={'20'}
                  addressWidth={'80'}
                />
                {bundleItem.tvItem && (
                  <>
                    <div className='bundle_sub_item'>
                      <ColumnHtml
                        item={`${bundleItem.tvItem.tvType == 'CellcomTV' ? `${window.Config.brand_Name_HE} TV` : `אפליקציה ${window.Config.brand_Name_HE} TV`}`}
                        columnWidth={widthList[0]}
                        customClass={'semiBold'}
                      />
                      {/* <ColumnTwoPartsHtml
                      title={'חבילות פרימיום'}
                      textWidth={'60%'}
                      titleWidth={'40%'}
                      text={premiumCount}
                      columnWidth={widthList[1]}
                      textCustomClass={'fs-24 pr-2'}
                    /> */}
                      <ColumnTwoPartsHtml
                        title={'ממירים'}
                        textWidth={'70%'}
                        titleWidth={'30%'}
                        columnWidth={widthList[2]}
                        text={equipment}
                        textCustomClass={'fs-24 pr-3'}
                      />
                      <ColumnHtml item={''} columnWidth={'55'} customClass={'justify-content-end'}>
                        <ServiceBoxTiny
                          isHaveBadge={false}
                          actionName={props.toAllActionButtonText.tv}
                          callback={() => {
                            props.goToAllAction(productsTypes.TV);
                          }}
                          backgroundColorProperty={props.toAllActionButtonText.color}
                          isBold={true}
                        />
                      </ColumnHtml>
                    </div>
                    {(bundleItem.internetItem || bundleItem.mapaItem || bundleItem.internetIsp) && <div className='item-border'></div>}
                  </>
                )}

                {bundleItem.internetItem && (
                  <>
                    <div className='bundle_sub_item'>
                      <ColumnHtml item={bundleItem.internetItem.packageName} columnWidth={widthList[0]} customClass={'semiBold'} />
                      <ColumnTwoPartsHtml
                        title={'מהירות גלישה'}
                        text={bundleItem.internetItem.downloadSpeed + 'Mb'}
                        textCustomClass={'fs-24 pr-3'}
                        textWidth={'60%'}
                        titleWidth={'40%'}
                        columnWidth={widthList[1]}
                      />

                      <ColumnHtml item={''} columnWidth={'55'} customClass={'justify-content-end'}>
                        <ServiceBoxTiny
                          isHaveBadge={false}
                          actionName={props.toAllActionButtonText.internet}
                          callback={() => {
                            props.goToAllAction(productsTypes.INTERNET);
                          }}
                          backgroundColorProperty={props.toAllActionButtonText.color}
                          isBold={true}
                        />
                      </ColumnHtml>
                    </div>
                    {(bundleItem.mapaItem || bundleItem.internetIsp) && <div className='item-border'></div>}
                  </>
                )}
                {bundleItem.internetIsp && (
                  <>
                    <div className='bundle_sub_item'>
                      <ColumnHtml item={bundleItem.internetIsp.packageName} columnWidth={widthList[0]} customClass={'semiBold'} />
                      <ColumnTwoPartsHtml
                        title={'משתמש'}
                        text={bundleItem.internetIsp.userName}
                        textCustomClass={'fs-24 pr-3'}
                        textWidth={'60%'}
                        titleWidth={'40%'}
                        columnWidth={widthList[1]}
                      />

                      <ColumnHtml item={''} columnWidth={'55'} customClass={'justify-content-end'}>
                        <ServiceBoxTiny
                          isHaveBadge={false}
                          actionName={props.toAllActionButtonText.internet}
                          callback={() => {
                            props.goToAllAction(productsTypes.INTERNET);
                          }}
                          backgroundColorProperty={props.toAllActionButtonText.color}
                          isBold={true}
                        />
                      </ColumnHtml>
                    </div>
                    {bundleItem.mapaItem && <div className='item-border'></div>}
                  </>
                )}
                {bundleItem.mapaItem && (
                  <div className='bundle_sub_item'>
                    <ColumnHtml item={'טלפון בית'} columnWidth={widthList[0]} customClass={'semiBold'} />
                    <ColumnTwoPartsHtml
                      title={'מספר קו'}
                      text={bundleItem.mapaItem.subscriberNumber?.replace(/^(.{2})(.*)$/, '$1-$2')}
                      textCustomClass={'fs-24 pr-3'}
                      columnWidth={widthList[1]}
                      textWidth={'60%'}
                      titleWidth={'40%'}
                    />

                    <ColumnHtml item={''} columnWidth={'55'} customClass={'justify-content-end'}>
                      <ServiceBoxTiny
                        isHaveBadge={false}
                        actionName={props.toAllActionButtonText.mapa}
                        callback={() => {
                          props.goToAllAction(productsTypes.MAPA);
                        }}
                        backgroundColorProperty={props.toAllActionButtonText.color}
                        isBold={true}
                      />
                    </ColumnHtml>
                  </div>
                )}
              </div>
            ) : (
              <div className='productAndServicesItemContainer_content_bundle_wrapper'>
                <BundleItemTitles
                  bundleName={bundleItem.packageName}
                  address={bundleItem.customerAddress}
                  bundleNameWidth={'100'}
                  addressWidth={'100'}
                />
                {bundleItem.tvItem && (
                  <>
                    <div className='bundle_sub_item'>
                      <ColumnTwoPartsHtml
                        title={`${bundleItem.tvItem.tvType == 'CellcomTV' ? `${window.Config.brand_Name_HE} TV` : `אפליקציה ${window.Config.brand_Name_HE} TV`}`}
                        titleCustomClass={'semiBold black align-items-center'}>
                        <Button
                          color={`link cellcomColor ${isMobile ? 'pl-0 mr-auto' : ''}`}
                          onClick={() => props.goToAllAction(productsTypes.TV)}>
                          {props.toAllActionButtonText.mobileText}
                        </Button>
                      </ColumnTwoPartsHtml>
                      {/* <ColumnTwoPartsHtml title={'חבילות פרימיום'} text={`${premiumCount}`} /> */}
                      <ColumnTwoPartsHtml title={'ממירים'} text={equipment} />
                    </div>
                    {(bundleItem.internetItem || bundleItem.mapaItem || bundleItem.internetIsp) && <div className='item-border'></div>}
                  </>
                )}
                {bundleItem.internetItem && (
                  <>
                    <div className='bundle_sub_item'>
                      <ColumnTwoPartsHtml
                        title={bundleItem.internetItem.packageName}
                        titleCustomClass={'semiBold black align-items-center'}>
                        <Button
                          color={`link cellcomColor ${isMobile ? 'pl-0 mr-auto' : ''}`}
                          onClick={() => props.goToAllAction(productsTypes.INTERNET)}>
                          {props.toAllActionButtonText.mobileText}
                        </Button>
                      </ColumnTwoPartsHtml>
                      <ColumnTwoPartsHtml title={'מהירות גלישה'} text={bundleItem.internetItem.downloadSpeed + 'Mb'} />
                    </div>
                    {(bundleItem.mapaItem || bundleItem.internetIsp) && <div className='item-border'></div>}
                  </>
                )}
                {bundleItem.internetIsp && (
                  <>
                    <div className='bundle_sub_item'>
                      <ColumnTwoPartsHtml title={bundleItem.internetIsp.packageName} titleCustomClass={'semiBold black align-items-center'}>
                        <Button
                          color={`link cellcomColor ${isMobile ? 'pl-0 mr-auto' : ''}`}
                          onClick={() => props.goToAllAction(productsTypes.INTERNET)}>
                          {props.toAllActionButtonText.mobileText}
                        </Button>
                      </ColumnTwoPartsHtml>
                      <ColumnTwoPartsHtml title={'משתמש'} text={bundleItem.internetIsp.userName} />
                    </div>
                    {bundleItem.mapaItem && <div className='item-border'></div>}
                  </>
                )}
                {bundleItem.mapaItem && (
                  <div className={`bundle_sub_item`}>
                    <ColumnTwoPartsHtml title={'טלפון בית'} titleCustomClass={'semiBold black align-items-center'}>
                      <Button
                        color={`link cellcomColor ${isMobile ? 'pl-0 mr-auto' : ''}`}
                        onClick={() => props.goToAllAction(productsTypes.MAPA)}>
                        {props.toAllActionButtonText.mobileText}
                      </Button>
                    </ColumnTwoPartsHtml>
                    <ColumnTwoPartsHtml title={'מספר קו'} text={bundleItem.mapaItem?.subscriberNumber?.replace(/^(.{2})(.*)$/, '$1-$2')} />
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
export default BundleItem;
